<div #tooltip class="custom-tooltip" [ngClass]="{ 'dark-tooltip': isDarkTheme, 'light-tooltip': !isDarkTheme }">
  <div class="tooltip-content" [innerHTML]="content"></div>
</div>
